export default function isNotEmpty(value) {
  if (Array.isArray(value)) {
    if (value.length === 0) {
      return false
    } else if (value.filter(v => isNotEmpty(v)).length === 0) {
      return false
    }
  }

  return value !== null
    && typeof value !== 'undefined'
    && value !== ''
    && value !== false
    || (Array.isArray(value) && value.length > 0 && value.filter(v => isNotEmpty(v)).length > 0)
}
